// Base on https://scotch.io/tutorials/how-to-implement-a-custom-validator-directive-confirm-password-in-angular-2
import { Attribute, Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NgModel, Validator } from '@angular/forms';

@Directive({
    selector: '[ahCompare]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CompareDirective), multi: true },
        NgModel
    ],
    standalone: false
})
export class CompareDirective implements Validator {
    constructor( @Attribute('ahCompare') private ahCompare, @Attribute('reverse') private reverse: string) { }

    validate(c: AbstractControl) {
        const v = c.value;
        const e = c.root.get(this.ahCompare);

        if (!this.isReverse()) {
            if (e && v !== e.value) {
                return {
                    ahCompare: false
                };
            }
        } else {
            if (e && v === e.value) {
                delete e.errors['ahCompare'];
                if (!Object.keys(e.errors).length) {
                    e.setErrors(null);
                }
            }

            if (e && v !== e.value) {
                e.setErrors({ ahCompare: false });
            }

        }

        return null;
    }

    private isReverse() {
        return this.reverse === 'true' ? true : false;
    }
}
